import { message } from "antd";
import { apiCallback } from "./Common";
import {
  APIResponseStatus,
  BulkDeviceCSVError,
  BulkDeviceCSVFormats,
  BulkDeviceFormats,
} from "../Constants/Constants";
import { element } from "prop-types";

export const onFormSubmit =
  ({ props, file, setError, setProcessing }) =>
  (values) => {
    const failMessage = "Error importing Devices!";
    const errorCallback = (error) => {
      message.error(failMessage);
      setProcessing(false);
    };
    const failCallback = (data) => {
      setProcessing(false);
      const error = [];
      if (data.toString().includes("Method Not Allowed")) {
        error.push(
         `${BulkDeviceCSVError.noPermissionToImportOrder}`
        );
      } else {
        if (data.id.includes(BulkDeviceCSVError.invalidFileName)) {
          error.push(
            `${data.info[0]?.error}` || `${BulkDeviceCSVError.invalidFileName}`
          );
        } else {
          data.info.forEach((dev) => {
            if (dev.deviceid) {
              error.push(`${dev.deviceid} ${dev.error}`);
            } else {
              error.push(`${dev.error}`);
            }
          });
        }
      }
      setError(error);
      if (!error.length) {
        message.success("All Devices imported successfully!");
        props.onSubmit();
      } else {
        data.id && message.error(data.id);
      }
    };
    const successCallback = (data) => {
      setProcessing(false);
      message.success("All Devices imported successfully!");
    };
    try {
      setError(null);
      setProcessing(true);
      console.log("onSubmit", values);
      const { history, deviceApi, orderApi } = props;
      if (values.format === BulkDeviceFormats.csv.value) {
        const params = {
          modelnumber: values.deviceModel,
          format: BulkDeviceCSVFormats.highJump.value,
          orderFile: file,
        };
        orderApi.importPurchaseOrder(
          params,
          apiCallback({
            history,
            errorCallback,
            failCallback,
            successCallback,
          })
        );
      } else {
        const deviceData = { devices: JSON.parse(values.devices) };
        deviceApi.importDevices(
          deviceData,
          apiCallback({
            history,
            errorCallback,
            failCallback: errorCallback,
            successCallback,
          })
        );
      }
    } catch (error) {
      errorCallback(error);
    }
  };
